import React, {useEffect, useRef, useState} from 'react'
import ReactPlayer from 'react-player'
import { SpeakerWaveIcon, PauseIcon, PlayIcon, SpeakerXMarkIcon } from '@heroicons/react/24/solid'
import {
  ArrowPathIcon,
  Bars3Icon,
  SpeakerXMarkIcon as SpeakerXMarkIconOutline,
  XMarkIcon
} from '@heroicons/react/24/outline'

const PROGRESS_INTERVAL = 100;

const initialOptions = {
  initialized: true,
  autoPlay: true,
  playing: true,
  muted: true,
}

const buttons = [
  {
    style: {
      top: '31.3%',
      left: '53.2%',
    },
    videoId: 1,
  },
  {
    style: {
      top: '31.3%',
      left: '71.6%',
    },
    videoId: 2,
  },
  {
    style: {
      top: '44%',
      left: '53.2%',
    },
    videoId: 3,
  },
  {
    style: {
      top: '44%',
      left: '71.6%',
    },
    videoId: 4,
  },
  {
    style: {
      top: '56.9%',
      left: '53.2%',
    },
    videoId: 5,
  },
  {
    style: {
      top: '56.9%',
      left: '71.6%',
    },
    videoId: 6,
  },
  {
    style: {
      top: '68.9%',
      left: '62.4%',
    },
    videoId: 7,
  },
]

const videos = [
  {
    id: 0,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/wprowadzenie/wprowadzenie.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/wprowadzenie.vtt',
    subtitlesPath: '',
    buttons_start_time: 9.78,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 1,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/przedsiebiorcy/przedsiebiorcy.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/przedsiebiorcy.vtt',
    subtitlesPath: '',
    buttons_start_time: 83.3,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 2,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/praca/praca.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/praca.vtt',
    subtitlesPath: '',
    buttons_start_time: 77.5,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 3,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/finanse_publiczne/finanse_publiczne.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/finanse_publiczne.vtt',
    subtitlesPath: '',
    buttons_start_time: 77.1,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 4,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/prawa_kobiet/prawa_kobiet.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/prawa_kobiet.vtt',
    subtitlesPath: '',
    buttons_start_time: 26.7,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 5,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/oze/oze.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/oze.vtt',
    subtitlesPath: '',
    buttons_start_time: 64,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 6,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/podatki/podatki.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/podatki.vtt',
    subtitlesPath: '',
    buttons_start_time: 88.5,
    buttons_end_time: 1000,
    buttons: buttons
  },
  {
    id: 7,
    hlsPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/idz_na_wybory/idz_na_wybory.m3u8',
    vttPath: 'https://leszczyna.s3.eu-west-1.amazonaws.com/videos/idz_na_wybory.vtt',
    subtitlesPath: '',
    buttons_start_time: 0,
    buttons_end_time: 0,
    buttons: buttons
  },
]

export default function VideoPlayer({  }) {
  const [options, setOptions] = useState(initialOptions);
  const [currentTime, setCurrentTime] = useState(0);
  const [watchPercent, setWatchPercent] = useState(0);
  const [currentVideo, setCurrentVideo] = useState(videos[0]);
  const [currentVideoSubtitles, setCurrentVideoSumtitles] = useState([]);
  const [currentSubtitles, setCurrentSubtitles] = useState(null);
  const [showMenu, setShowMenu] = useState(false);
  const playerRef = useRef();

  useEffect(() => {
    getSubtitles(currentVideo.vttPath)
  }, [currentVideo]);

  const getSubtitles = async () => {
    const vttText = await fetchTVVSubtitlesFromURL(currentVideo.vttPath);
    const subtitles = vttToSubtitleArray(vttText)

    setCurrentVideoSumtitles(subtitles)
  }

  const vttToSubtitleArray = vttText => {
    const lines = vttText.trim().split('\n');
    const subtitleArray = [];
    let currentSubtitle = {};

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();

      if (line === 'WEBVTT') {
        continue;
      }

      if (line.includes('-->')) {
        const [timestamp, endTime] = line.split(' --> ');
        currentSubtitle.startTime = timestampToSeconds(timestamp.trim());
        currentSubtitle.endTime = timestampToSeconds(endTime.trim());
      } else if (line !== '') {
        if (currentSubtitle.text) {
          currentSubtitle.text += ' ' + line;
        } else {
          currentSubtitle.text = line;
        }
      }

      if (i + 1 === lines.length || lines[i + 1].trim() === '') {
        if (Object.keys(currentSubtitle).length > 0) {
          subtitleArray.push(currentSubtitle);
          currentSubtitle = {};
        }
      }
    }

    return subtitleArray;
  }

  const fetchTVVSubtitlesFromURL = async (url) => {
    try {
      const response = await fetch(url);

      return await response.text();
    } catch (error) {
      console.error(error);
      return [];
    }
  }

  function timestampToSeconds(timestamp) {
    const [minutes, seconds] = timestamp.split(':').map(parseFloat);
    return minutes * 60 + seconds;
  }

  const handleProgress = data => {
    const percent = parseInt(data.played * 100);

    setCurrentSubtitles(currentVideoSubtitles.find(subtitles => data.playedSeconds >= subtitles.startTime && data.playedSeconds <= subtitles.endTime)?.text)

    setCurrentTime(data.playedSeconds);

    setWatchPercent(percent);

    if (percent === 100) {
      handlePause();
    }
  }

  const handlePause = () => {
    setOptions(data => ({
      ...data,
      playing: false,
      autoPlay: false,
    }))
  }

  const handlePlay = () => {
    setOptions(data => ({
      ...data,
      playing: true,
      autoPlay: true,
    }))
  }

  const toggleMuted = () => {
    const muted = !options.muted;

    setOptions(data => ({
      ...data,
      muted,
    }))
  }

  const handleSeek = e => {
    e.stopPropagation();

    const rect = e.target.getBoundingClientRect();
    const percent = (e.clientX - rect.left) / rect.width;

    playerRef.current.seekTo(percent, 'fraction')
  }

  const handleRestart = () => {
    playerRef.current.seekTo(0, 'fraction')
    setCurrentVideo(videos[0])
    setCurrentTime(0);
    setWatchPercent(0);
    handlePlay();
  }

  const handleVideo = videoId => {
    setShowMenu(false);

    if (currentVideo.id !== videoId) {
      setCurrentVideo(videos.find(video => video.id === videoId));
    }

    playerRef.current.seekTo(0, 'fraction')
    setCurrentTime(0);
    setWatchPercent(0);
    handlePlay();
  }

  const handleToggleMenu = () => {
    setShowMenu(showMenu => !showMenu)
  }

  return (
      <>
        <div className="flex flex-col h-screen max-h-screen bg-white">
          <div className="sm:min-h-[230px] max-h-screen">
            <div className="aspect-video max-h-full mx-auto relative bg-[#042347]">
              <ReactPlayer
                  width="100%"
                  height="100%"
                  className=""
                  playsinline={true}
                  controls={false}
                  url={currentVideo.hlsPath}
                  playing={options.playing}
                  autoPlay={options.autoPlay}
                  muted={options.muted}
                  progressInterval={PROGRESS_INTERVAL}
                  onProgress={handleProgress}
                  ref={playerRef}
                  key={currentVideo.id}
                  config={{
                    autoPlay: true,
                  }}
              />

              <div className={`absolute top-2 sm:top-5 z-20 ${showMenu ? 'left-[210px] sm:left-[310px]' : 'left-2 sm:left-5'}`}>
                <button type="button" className="flex items-center space-x-3 bg-white text-gray-700 rounded px-1 sm:px-3 py-1 sm:py-2 text-sm sm:text-md" onClick={handleToggleMenu}>
                  {showMenu ? <XMarkIcon className="w-4 sm:w-6" /> : <Bars3Icon className="w-4 sm:w-6" />}
                  <span>Menu</span>
                </button>
              </div>

              {showMenu && <>
                <div className="absolute left-0 top-0 w-[200px] sm:w-[300px] bg-black/40 z-10 overflow-y-auto" style={{ height: 'calc(100% - 36px)'}}>
                  <ul className="sm:py-5 sm:px-5 divide-y divide-white text-left overflow-w-hidden overflow-y-auto">
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10 sm:border-t border-white" onClick={() => handleVideo(1)}>Przedsiębiorcy</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10" onClick={() => handleVideo(2)}>Praca</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10" onClick={() => handleVideo(3)}>Finanse Publiczne</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10" onClick={() => handleVideo(4)}>Prawa Kobiet</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10" onClick={() => handleVideo(5)}>OZE</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10" onClick={() => handleVideo(6)}>Podatki</button>
                    </li>
                    <li>
                      <button type="button" className="px-2 sm:px-5 py-1 sm:py-3 text-sm sm:text-md w-full text-left text-white hover:bg-white/10 sm:border-b border-white" onClick={() => handleVideo(7)}>Idź na wybory</button>
                    </li>
                  </ul>
                </div>
              </>}

              {options.muted && <>
                <div className="absolute right-2 sm:right-5 top-2 sm:top-5 z-10">
                  <button type="button" className="flex items-center space-x-3 bg-white text-gray-700 rounded px-1 sm:px-3 py-1 sm:py-2 text-sm sm:text-md" onClick={toggleMuted}>
                    <SpeakerXMarkIconOutline className="w-4 sm:w-6 stroke-gray-700" />
                    <span>Włącz dźwięk</span>
                  </button>
                </div>
              </>}

              {currentSubtitles && <div className="absolute left-1/2 bottom-[50px] -translate-x-1/2 w-3/4">
                <div className="subtitles">
                  {currentSubtitles}
                </div>
              </div>}

              <div className="interactive-layer">
                {currentTime > currentVideo.buttons_start_time && currentTime < currentVideo.buttons_end_time && <>
                  {watchPercent === 100 && !options.muted && <>
                    <audio
                      autoPlay={true}
                      src="https://leszczyna.s3.eu-west-1.amazonaws.com/tmp_videos/iza2.mp3"
                    />
                  </>}

                  {currentVideo.buttons.map((button, index) =>
                    <button
                      type="button"
                      className="absolute rounded hover:bg-white/10 focus:hover:bg-white/20 active:bg-white/30 w-[16.35%] h-[7.1%]"
                      key={index}
                      onClick={() => handleVideo(button.videoId)} style={button.style}
                    />
                  )}
                </>}
              </div>

              <div className="absolute left-0 bottom-0 w-full">
                <div className="h-[36px] bg-black/40">
                  <div className="flex justify-between items-center h-full">
                    <div className="flex items-center mt-[1px]">
                      {options.playing ? <>
                        <button type="button" className="py-1 px-2 h-[32px]" onClick={handlePause} aria-label="Zatrzymaj film">
                          <PauseIcon className="w-6 h-6 fill-white hover:fill-blue-50" />
                        </button>
                      </> : <>
                        <button type="button" className="py- px-2 h-[32px]" onClick={handlePlay} aria-label="Odtwarzaj film">
                          <PlayIcon className="w-6 h-6 fill-white hover:fill-blue-50" />
                        </button>
                      </>}
                      <button type="button" className="py-1 px-2 h-[32px]" onClick={toggleMuted} aria-label={`${options.muted ? 'Włącz dzwięk' : 'Wyłącz dzwięk'}`}>
                        {options.muted ? <>
                          <SpeakerXMarkIcon className="w-6 h-6 fill-white hover:fill-blue-50" />
                        </> : <>
                          <SpeakerWaveIcon className="w-6 h-6 fill-white hover:fill-blue-50" />
                        </>}
                      </button>
                    </div>

                    <div className="flex items-center flex-1 h-[25px] mx-4 group cursor-pointer" onClick={handleSeek}>
                      <div className="h-[3px] w-full group-hover:h-[5px] bg-gray-300">
                        <div className={`h-full bg-blue-400 transition-all ease-linear pointer-events-none duration-${PROGRESS_INTERVAL}`} style={{ width: `${watchPercent}%` }}></div>
                      </div>
                    </div>
                    <div className="flex items-center mr-2">
                      <button type="button" className={`px-2 ${currentVideo.id === 7 ? 'flex' : 'hidden'}`} onClick={handleRestart}>
                        <ArrowPathIcon className="w-6 h-6 stroke-white" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
  );
}
